import { Component } from '@angular/core';

@Component({
  selector: 'mtm-arrow-drawing-icon',
  templateUrl: './arrow-drawing-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class ArrowDrawingIconComponent {}
